<script>
import checkedImg from "../../assets/checked.png";
import checkImg from "../../assets/check.png";
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick() {
      this.$emit("input", !this.value);
    }
  },
  render() {
    if (this.value) {
      return <img src={checkedImg} onClick={this.onClick} />;
    } else {
      return <img src={checkImg} onClick={this.onClick} />;
    }
  }
};
</script>
